"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Headers = void 0;
// Note these are lowercase since https headers are converted to lowercase anyway
var Headers;
(function (Headers) {
    Headers["CUSTOM_USER_AGENT"] = "x-user-agent";
})(Headers || (exports.Headers = Headers = {}));
